<ng-container *ngIf="route_eCMR && route_eCMR.hasAccessDigitalDocument">
  <div class="line">
    <span *ngIf="route_eCMR.eCMRType == 'CMR'" class="ecmr-title">{{ 'ECMR.CMR.TITLE' | translate }}</span>
    <span *ngIf="route_eCMR.eCMRType == 'DCA'" class="ecmr-title">{{ 'ECMR.DCA.TITLE' | translate }}</span>
  </div>
  <div class="line">
    <span class="ecmr-title">
      {{ route_eCMR.eCMRKey }}
      <shared-copyclipboard [value]="route_eCMR.eCMRKey"></shared-copyclipboard>
    </span>
    <div *ngIf="contract" class="contract-toggle">
      <a (click)="showAll = !showAll">
        <ng-container *ngIf="showAll">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
          {{'GENERAL.RESUMED.OFF.CAPTION' | translate }}
        </ng-container>
        <ng-container *ngIf="!showAll">
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
          {{'GENERAL.RESUMED.ON.CAPTION' | translate }}
        </ng-container>
      </a>
    </div>
  </div>

  <!-- EXPEDIDOR -->
  <div *ngIf="!route_eCMR.hideExpeditor || showAll" [@fadeInOut] class="ecmr-block expeditor">
    <span class="ecmr-block-title">
      {{ 'ECMR.EXPEDITOR.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || originTenantBlank()) && !readonly" (click)="updateOriginTenant = true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || originTenantBlank()) && !readonly" (click)="resetOriginTenant()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updateOriginTenant" title="ECMR.EXPEDITOR.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="origin" [tenantId]="route_eCMR.originTenantId"
      [name]="route_eCMR.originTenantName" [nif]="route_eCMR.originTenantNif"
      [manualAddress]="route_eCMR.originTenantAddress" [contactName]="route_eCMR.originTenantContactName"
      [contactPhone]="route_eCMR.originTenantContactPhone" (onConfirm)="loadCMR()"
      (onCancel)="updateOriginTenant=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.originTenantName || route_eCMR.originTenantNif">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.originTenantName }}
            <shared-copyclipboard [value]="route_eCMR.originTenantName"></shared-copyclipboard>
          </div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.originTenantNif }}
            <shared-copyclipboard [value]="route_eCMR.originTenantNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.originTenantAddress?.formattedAddress">
            {{ route_eCMR.originTenantAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(null, route_eCMR.originTenantAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
          <div>{{ route_eCMR.originTenantContactName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="phone" *ngIf="route_eCMR.originTenantContactPhone">
            <a href="{{ 'tel:' + route_eCMR.originTenantContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.originTenantContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.originTenantContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- DESTINATARI -->
  <div *ngIf="!route_eCMR.hideDestinatary || showAll" [@fadeInOut] class="ecmr-block destinatary">
    <span class="ecmr-block-title">
      {{ 'ECMR.RECIPIENT.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || destinationTenantBlank()) && !readonly"
        (click)="updateDestinationTenant = true" class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || destinationTenantBlank()) && !readonly" (click)="resetDestinationTenant()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updateDestinationTenant" title="ECMR.RECIPIENT.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="destination" [tenantId]="route_eCMR.destinationTenantId"
      [name]="route_eCMR.destinationTenantName" [nif]="route_eCMR.destinationTenantNif"
      [manualAddress]="route_eCMR.destinationTenantAddress" [contactName]="route_eCMR.destinationTenantContactName"
      [contactPhone]="route_eCMR.destinationTenantContactPhone" (onConfirm)="loadCMR()"
      (onCancel)="updateDestinationTenant=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.destinationTenantName || route_eCMR.destinationTenantNif">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.destinationTenantName }}
            <shared-copyclipboard [value]="route_eCMR.destinationTenantName"></shared-copyclipboard>
          </div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.destinationTenantNif }}
            <shared-copyclipboard [value]="route_eCMR.destinationTenantNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.destinationTenantAddress?.formattedAddress">
            {{ route_eCMR.destinationTenantAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(null, route_eCMR.destinationTenantAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
          <div>{{ route_eCMR.destinationTenantContactName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="phone" *ngIf="route_eCMR.destinationTenantContactPhone">
            <a href="{{ 'tel:' + route_eCMR.destinationTenantContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.destinationTenantContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.destinationTenantContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- APPLICANT -->
  <div *ngIf="!route_eCMR.hideApplicant || showAll" [@fadeInOut] class="ecmr-block applicant">
    <span class="ecmr-block-title">
      {{ 'ECMR.APPLICANT.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || applicantBlank()) && !readonly" (click)="updateApplicant = true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || applicantBlank()) && !readonly" (click)="resetApplicant()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updateApplicant" title="ECMR.APPLICANT.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="applicant" [name]="route_eCMR.applicantName"
      [nif]="route_eCMR.applicantNif" [manualAddress]="route_eCMR.applicantAddress"
      [contactName]="route_eCMR.applicantContactName" [contactPhone]="route_eCMR.applicantContactPhone"
      (onConfirm)="loadCMR()" (onCancel)="updateApplicant=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.applicantName || route_eCMR.applicantNif">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.applicantName }}
            <shared-copyclipboard [value]="route_eCMR.applicantName"></shared-copyclipboard>
          </div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.applicantNif }}
            <shared-copyclipboard [value]="route_eCMR.applicantNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.applicantAddress?.formattedAddress">
            {{ route_eCMR.applicantAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(null, route_eCMR.applicantAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
          <div>{{ route_eCMR.applicantContactName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="phone" *ngIf="route_eCMR.applicantContactPhone">
            <a href="{{ 'tel:' + route_eCMR.applicantContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.applicantContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.applicantContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PAGADOR -->
  <div *ngIf="!route_eCMR.hidePayer || showAll" [@fadeInOut] class="ecmr-block payer">
    <span class="ecmr-block-title">
      {{ 'ECMR.PAYER.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || payerBlank()) && !readonly" (click)="updatePayer = true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || payerBlank()) && !readonly" (click)="resetPayer()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updatePayer" title="ECMR.PAYER.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="payer" [name]="route_eCMR.payerName" [nif]="route_eCMR.payerNif"
      [manualAddress]="route_eCMR.payerAddress" [contactName]="route_eCMR.payerContactName"
      [contactPhone]="route_eCMR.payerContactPhone" (onConfirm)="loadCMR()"
      (onCancel)="updatePayer=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.payerName || route_eCMR.payerNif">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.payerName }}
            <shared-copyclipboard [value]="route_eCMR.payerName"></shared-copyclipboard>
          </div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.payerNif }}
            <shared-copyclipboard [value]="route_eCMR.payerNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.payerAddress?.formattedAddress">
            {{ route_eCMR.payerAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(null, route_eCMR.payerAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
          <div>{{ route_eCMR.payerContactName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="phone" *ngIf="route_eCMR.payerContactPhone">
            <a href="{{ 'tel:' + route_eCMR.payerContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.payerContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.payerContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
    <!-- PREU -->
    <div *ngIf="!route_eCMR.hidePayment || showAll" class="ecmr-block sub payment">
      <span class="ecmr-block-title">
        {{ 'ECMR.PAYMENT.TITLE' | translate }}
        <mat-icon *ngIf="(route_eCMR.isOwner || paymentBlank()) && !readonly" (click)="updatePayment = true"
          class="material-icons-outlined">edit</mat-icon>
        <mat-icon *ngIf="(route_eCMR.isOwner || paymentBlank()) && !readonly" (click)="resetPayment()"
          class="material-icons-outlined">refresh</mat-icon>
      </span>

      <updatepayment-dialog [external]="external" [expanded]="updatePayment" title="ECMR.PAYMENT.TITLE"
        [routePartCMRId]="routePartCMRId" [payment]="route_eCMR.payment" [amount]="route_eCMR.amount"
        (onConfirm)="loadCMR()" (onCancel)="updatePayment=false"></updatepayment-dialog>

      <div class="ecmr-block-content">
        <div class="ecmr-block-row" *ngIf="route_eCMR.payment">
          <div class="ecmr-block-col">
            <div>{{ route_eCMR.payment }}</div>
          </div>
          <div class="ecmr-block-col">
            <div>{{'ROUTEPARTCMR.MAINTENANCE.ADDITIONALDATA.AMOUNT.CAPTION' | translate}}: {{ route_eCMR.amount }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- CARRIER -->
  <div *ngIf="!route_eCMR.hideCarrier || showAll" [@fadeInOut] class="ecmr-block carrier">
    <span class="ecmr-block-title">
      {{ 'ECMR.CARRIER.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || carrierBlank()) && !readonly" (click)="updateCarrier = true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || carrierBlank()) && !readonly" (click)="resetCarrier()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updateCarrier" title="ECMR.CARRIER.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="carrier" [name]="route_eCMR.carrierName"
      [nif]="route_eCMR.carrierNif" [manualAddress]="route_eCMR.carrierAddress"
      [contactName]="route_eCMR.carrierContactName" [contactPhone]="route_eCMR.carrierContactPhone"
      (onConfirm)="loadCMR()" (onCancel)="updateCarrier=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.carrierName || route_eCMR.carrierNif">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.carrierName }}
            <shared-copyclipboard [value]="route_eCMR.carrierName"></shared-copyclipboard>
          </div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.carrierNif }}
            <shared-copyclipboard [value]="route_eCMR.carrierNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.carrierAddress?.formattedAddress">
            {{ route_eCMR.carrierAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(null, route_eCMR.carrierAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
          <div>{{ route_eCMR.carrierContactName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="phone" *ngIf="route_eCMR.carrierContactPhone">
            <a href="{{ 'tel:' + route_eCMR.carrierContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.carrierContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.carrierContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- EFFECTIVE CARRIER -->
  <div *ngIf="!route_eCMR.hideEffectiveCarrier || showAll" [@fadeInOut] class="ecmr-block effectivecarrier">
    <span class="ecmr-block-title">
      {{ 'ECMR.EFFECTIVECARRIER.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || effectiveCarrierBlank()) && !readonly"
        (click)="updateEffectiveCarrier = true" class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || effectiveCarrierBlank()) && !readonly" (click)="resetEffectiveCarrier()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updateEffectiveCarrier" title="ECMR.EFFECTIVECARRIER.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="effectivecarrier" [name]="route_eCMR.effectiveCarrierName"
      [nif]="route_eCMR.effectiveCarrierNif" [manualAddress]="route_eCMR.effectiveCarrierAddress"
      [contactName]="route_eCMR.effectiveCarrierContactName" [contactPhone]="route_eCMR.effectiveCarrierContactPhone"
      (onConfirm)="loadCMR()" (onCancel)="updateEffectiveCarrier=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.effectiveCarrierName || route_eCMR.effectiveCarrierNif">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.effectiveCarrierName }}
            <shared-copyclipboard [value]="route_eCMR.effectiveCarrierName"></shared-copyclipboard>
          </div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.effectiveCarrierNif }}
            <shared-copyclipboard [value]="route_eCMR.effectiveCarrierNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.effectiveCarrierAddress?.formattedAddress">
            {{ route_eCMR.effectiveCarrierAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(null, route_eCMR.effectiveCarrierAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
          <div>{{ route_eCMR.effectiveCarrierContactName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="phone" *ngIf="route_eCMR.effectiveCarrierContactPhone">
            <a href="{{ 'tel:' + route_eCMR.effectiveCarrierContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.effectiveCarrierContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.effectiveCarrierContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- DRIVER -->
  <div *ngIf="(!route_eCMR.hideDriver || showAll) && route_eCMR.driverName" [@fadeInOut] class="ecmr-block driver">
    <span class="ecmr-block-title">
      {{ 'ECMR.DRIVER.TITLE' | translate }}
      <mat-icon *ngIf="(route_eCMR.isOwner || driverBlank()) && !readonly" (click)="updateDriver = true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || driverBlank()) && !readonly" (click)="resetDriver()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatepartner-dialog [external]="external" [expanded]="updateDriver" title="ECMR.DRIVER.TITLE"
      [routePartCMRId]="routePartCMRId" partnerType="driver" [name]="route_eCMR.driverName" [nif]="route_eCMR.driverNif"
      [contactPhone]="route_eCMR.driverPhone" (onConfirm)="loadCMR()"
      (onCancel)="updateDriver=false"></updatepartner-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.driverName }}</div>
        </div>
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.driverNif }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.driverNif"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
        </div>
        <div class="ecmr-block-col" *ngIf="route_eCMR.driverPhone">
          <div class="phone">
            <a href="{{ 'tel:' + route_eCMR.driverPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.driverPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.driverPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- PLATES -->
  <div [@fadeInOut] class="ecmr-block plates">
    <span class="ecmr-block-title">
      {{ 'ECMR.PLATES.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || platesBlank()) && !readonly" (click)="updatePlates=true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || platesBlank()) && !readonly" (click)="resetPlates()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updateplates-dialog [external]="external" [expanded]="updatePlates" title="ECMR.PLATES.TITLE"
      [routePartCMRId]="routePartCMRId" [plateA]="route_eCMR.plateA" [plateB]="route_eCMR.plateB"
      [plateC]="route_eCMR.plateC" (onConfirm)="loadCMR()" (onCancel)="updatePlates=false"></updateplates-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.plateA || route_eCMR.plateB || route_eCMR.plateC">
        <div class="ecmr-block-col plateA">
          <span class="title-text">{{ 'ECMR.PLATES.PLATE_A' | translate }}</span>
          <span class="value-text">{{ route_eCMR.plateA }}</span>
        </div>
        <div class="ecmr-block-col plateB">
          <span class="title-text">{{ 'ECMR.PLATES.PLATE_B' | translate }}</span>
          <span class="value-text">{{ route_eCMR.plateB }}</span>
        </div>
        <div class="ecmr-block-col plateC">
          <span class="title-text">{{ 'ECMR.PLATES.PLATE_C' | translate }}</span>
          <span class="value-text">{{ route_eCMR.plateC }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- TRANSPORT DATE -->
  <div [@fadeInOut] class="ecmr-block transport-date">
    <span class="ecmr-block-title">
      {{ 'ECMR.TRANSPORTDATE.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || transportDateBlank()) && !readonly" (click)="updateTransportDate=true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || transportDateBlank()) && !readonly" (click)="resetTransportDate()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updatetransportdate-dialog [external]="external" [expanded]="updateTransportDate" title="ECMR.TRANSPORTDATE.TITLE"
      [routePartCMRId]="routePartCMRId" [moment]="route_eCMR.transportDate" momentType="updateTransportDate"
      (onConfirm)="loadCMR()" (onCancel)="updateTransportDate=false"></updatetransportdate-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.transportDate">
        <div class="ecmr-block-col">
          <span class="value-text">{{ route_eCMR.transportDate | date }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- INCOTERM -->
  <div *ngIf="!route_eCMR.hideIncoterm || showAll" [@fadeInOut] class="ecmr-block incoterm">
    <span class="ecmr-block-title">
      {{ 'ECMR.INCOTERM.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || incotermBlank()) && !readonly" (click)="incotermExpanded=true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || incotermBlank()) && !readonly" (click)="resetIncoterm()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>
    <updateincoterm-dialog [external]="external" [expanded]="incotermExpanded" title="ECMR.INCOTERM.TITLE"
      [routePartCMRId]="routePartCMRId" [incoterm]="route_eCMR.incoterm" (onConfirm)="loadCMR()"
      (onCancel)="incotermExpanded=false"></updateincoterm-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.incoterm && route_eCMR.incoterm != incotermNone ">
        <div class="ecmr-block-col">
          <div class="name key">{{ route_eCMR.incoterm }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- ADREÇA ORIGEN -->
  <div *ngIf="!route_eCMR.hideOriginAddress || showAll" [@fadeInOut] class="ecmr-block expeditor">
    <span class="ecmr-block-title">
      {{ 'ECMR.ORIGINADDRESS.TITLE' | translate }}
      <mat-icon *ngIf="(route_eCMR.isOwner || originAddressBlank()) && !readonly" (click)="updateOriginAddress = true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || originAddressBlank()) && !readonly" (click)="resetOriginAddress()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updateaddress-dialog [external]="external" [expanded]="updateOriginAddress" title="ECMR.ORIGINADDRESS.TITLE"
      [routePartCMRId]="routePartCMRId" [name]="route_eCMR.originAddressName" [key]="route_eCMR.originAddressKey"
      [manualAddress]="route_eCMR.originAddress" [contactPhone]="route_eCMR.originContactPhone" [isOrigin]="true"
      (onConfirm)="loadCMR()" (onCancel)="updateOriginAddress=false"></updateaddress-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.originAddressName">
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.originAddressName }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.originAddressName"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.originAddress?.formattedAddress">
            {{ route_eCMR.originAddress?.formattedAddress }}&nbsp;
            <mat-icon (click)="obrirDireccio(route_eCMR.originAddressId, route_eCMR.originAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
        </div>
        <div class="ecmr-block-col" *ngIf="route_eCMR.originContactPhone">
          <div class="phone">
            <a href="{{ 'tel:' + route_eCMR.originContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.originContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.originContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ADREÇA DESTI -->
  <div *ngIf="!route_eCMR.hideDestinataryAddress || showAll" [@fadeInOut] class="ecmr-block destinatary">
    <span class="ecmr-block-title">
      {{ 'ECMR.DESTINATIONADDRESS.TITLE' | translate }}
      <mat-icon *ngIf="(route_eCMR.isOwner || destinationAddressBlank()) && !readonly"
        (click)="updateDestinationAddress = true" class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || destinationAddressBlank()) && !readonly"
        (click)="resetDestinationAddress()" class="material-icons-outlined">refresh</mat-icon>
    </span>

    <updateaddress-dialog [external]="external" [expanded]="updateDestinationAddress"
      title="ECMR.DESTINATIONADDRESS.TITLE" [routePartCMRId]="routePartCMRId" [name]="route_eCMR.destinationAddressName"
      [key]="route_eCMR.destinationAddressKey" [manualAddress]="route_eCMR.destinationAddress"
      [contactPhone]="route_eCMR.destinationContactPhone" [isDestination]="true" (onConfirm)="loadCMR()"
      (onCancel)="updateDestinationAddress=false"></updateaddress-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.destinationAddressName">
        <div class="ecmr-block-col">
          <div class="key">{{ route_eCMR.destinationAddressName }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.destinationAddressName"></shared-copyclipboard>
          </div>
        </div>
      </div>
      <div class="ecmr-block-row">
        <div class="ecmr-block-col">
          <div class="address" *ngIf="route_eCMR.destinationAddress?.formattedAddress">
            {{ route_eCMR.destinationAddress?.formattedAddress }}&nbsp;
            <mat-icon
              (click)="obrirDireccio(route_eCMR.destinationAddressId, route_eCMR.destinationAddress?.formattedAddress)"
              class="material-icons-outlined">location_on</mat-icon>
          </div>
        </div>
        <div class="ecmr-block-col" *ngIf="route_eCMR.destinationContactPhone">
          <div class="phone">
            <a href="{{ 'tel:' + route_eCMR.destinationContactPhone }}">
              <mat-icon class="material-icons-outlined">call_outline</mat-icon>
            </a>
            {{ route_eCMR.destinationContactPhone }}&nbsp;
            <shared-copyclipboard [value]="route_eCMR.destinationContactPhone"></shared-copyclipboard>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MERCADERIES -->
  <div *ngIf="!route_eCMR.hideDeliveryLines || showAll" class="ecmr-block deliveryLines">
    <span class="ecmr-block-title">
      {{ 'ECMR.DELIVERYLINES.TITLE' | translate }}
      <mat-icon *ngIf="(route_eCMR.isOwner || deliveryLinesBlank()) && !readonly" (click)="deliveryLinesExpanded=true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || deliveryLinesBlank()) && !readonly" (click)="resetDeliveryLines()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>
    <updatedeliverylines-dialog [external]="external" [expanded]="deliveryLinesExpanded"
      title="ECMR.DELIVERYLINES.TITLE" [routePartCMRId]="routePartCMRId" [route_eCMR]="route_eCMR"
      (onConfirm)="loadCMR()" (onCancel)="deliveryLinesExpanded=false"></updatedeliverylines-dialog>

    <div class="ecmr-block-content" *ngIf="route_eCMR.deliveryLines">
      <div *ngIf="route_eCMR.deliveryLines.length > 0">
        <div class="ecmr-block-row" *ngFor="let line of route_eCMR.deliveryLines | sortBy:'order'; let i=index">
          <shared-delivery-line class="line compact" [line]="line" [columns]="deliveryLineColumns"
            [allColumns]="deliveryLineColumnsSupported" [readonly]="true" [showDelete]="false"
            [expanded]="isDeliveryLineExpanded(line)" (expandToggled)="onExpandedDeliveryLine(line)">
          </shared-delivery-line>
        </div>
        <div class="ecmr-block sub">
          <div class="ecmr-block-row totalKg">
            <span class="value-text">{{'ECMR.TOTALKG.CAPTION' | translate}}</span>
            <span class="key">{{ route_eCMR.totalKg | quantity }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="route_eCMR.deliveryLines.length == 0">
        <div class="ecmr-block-row totalKg">
          <span class="value-text">{{'ECMR.TOTALKG.CAPTION' | translate}}</span>
          <span class="key">{{ route_eCMR.totalKg | quantity }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- CONDICIONS -->
  <div *ngIf="!route_eCMR.hideConditions || showAll" [@fadeInOut] class="ecmr-block conditions">
    <span class="ecmr-block-title">
      {{ 'ECMR.CONDITIONS.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || conditionsBlank()) && !readonly" (click)="conditionsExpanded=true"
        class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || conditionsBlank()) && !readonly" (click)="resetConditions()"
        class="material-icons-outlined">refresh</mat-icon>
    </span>
    <updateconditions-dialog [external]="external" [expanded]="conditionsExpanded" title="ECMR.CONDITIONS.TITLE"
      [routePartCMRId]="routePartCMRId" [conditions]="route_eCMR.conditions" (onConfirm)="loadCMR()"
      (onCancel)="conditionsExpanded=false"></updateconditions-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.conditions">
        <span class="line-data">{{ route_eCMR.conditions }}</span>
      </div>
    </div>
  </div>

  <!-- MANIPULACIÓ I TRANSPORT -->
  <div *ngIf="!route_eCMR.hideHandlingAndTransportation || showAll" [@fadeInOut]
    class="ecmr-block handlingAndTransportation">
    <span class="ecmr-block-title">
      {{ 'ECMR.HANDLINGANDTRANSPORTATION.TITLE' | translate}}
      <mat-icon *ngIf="(route_eCMR.isOwner || handlingAndTransportationBlank()) && !readonly"
        (click)="handlingAndTransportationExpanded=true" class="material-icons-outlined">edit</mat-icon>
      <mat-icon *ngIf="(route_eCMR.isOwner || handlingAndTransportationBlank()) && !readonly"
        (click)="resetHandlingAndTransportation()" class="material-icons-outlined">refresh</mat-icon>
    </span>
    <updatehandlingandtransportation-dialog [external]="external" [expanded]="handlingAndTransportationExpanded"
      title="ECMR.HANDLINGANDTRANSPORTATION.TITLE" [routePartCMRId]="routePartCMRId"
      [handlingAndTransportation]="route_eCMR.handlingAndTransportation" (onConfirm)="loadCMR()"
      (onCancel)="handlingAndTransportationExpanded=false"></updatehandlingandtransportation-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.handlingAndTransportation">
        <span class="line-data">{{ route_eCMR.handlingAndTransportation }}</span>
      </div>
    </div>
  </div>

  <!-- EVENTS -->
  <div *ngIf="!route_eCMR.hideEvents || showAll" [@fadeInOut] class="ecmr-block events">
    <span class="ecmr-block-title">
      {{ 'ECMR.EVENTS.TITLE' | translate }}
      <mat-icon *ngIf="!readonly" (click)="addEvent = true" class="material-icons-outlined">add</mat-icon>
    </span>
    <addevent-dialog [external]="external" [expanded]="addEvent" title="ECMR.EVENTS.ADD.TITLE"
      [routePartCMRId]="routePartCMRId" (onConfirm)="loadCMR()" (onCancel)="addEvent=false"></addevent-dialog>

    <div class="ecmr-block-content">
      <div class="ecmr-block-row" *ngIf="route_eCMR.events && route_eCMR.events.length > 0">
        <shared-cmr-events-list class="minimalist" [events]="route_eCMR.events"></shared-cmr-events-list>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="route_eCMR != null && !route_eCMR.hasAccessDigitalDocument">
  <div class="document-notvisible">
      <div *ngIf="route_eCMR?.isOwner" class="inner-document-notvisible"
          [innerHTML]="'ECMR.DOCUMENT.NOTVISIBLE.OWNER.CAPTION' | translate | safe: 'html'">
      </div>
      <div *ngIf="!route_eCMR?.isOwner" class="inner-document-notvisible"
          [innerHTML]="'ECMR.DOCUMENT.NOTVISIBLE.OTHER.CAPTION' | translate:{ payerName: route_eCMR?.payerName } | safe: 'html'">
      </div>
  </div>
</ng-container>